<template>
  <div>
    <div class="cs-autonomousEnrolment-workflow" v-loading="isLoading || isSaving">
      <el-row>
        <el-col>
          <el-steps :active="activeStep" process-status="finish" finish-status="success" simple>
            <el-step title="添加课程" :status="getStepStatus(1)" @click.native="onStepItemClick(1)"></el-step>
            <el-step title="计算价格" :status="getStepStatus(2)" @click.native="onStepItemClick(2)"></el-step>
            <el-step title="缴付款项" :status="getStepStatus(3)" @click.native="onStepItemClick(3)"></el-step>
            <el-step title="报名成功" :status="getStepStatus(4)" @click.native="onStepItemClick(4)"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <el-row class="grid-content">
        <el-col v-if="!isLoading">
          <workflowStep1 ref="workflowStep1" v-show="activeStep === 1" :isReadonly="isReadonly" :dataIn="step1Model"
            @edit="onEdit">
          </workflowStep1>
          <workflowStep2 ref="workflowStep2" v-show="activeStep === 2" :isReadonly="isReadonly" :dataIn="step2Model"
            @edit="onEdit" @calculate="onCalculate" @useBalanceEditorValueChange="onUseBalanceEditorValueChange">
          </workflowStep2>
          <workflowStep3 ref="workflowStep3" v-show="activeStep === 3 || activeStep === 4" :isReadonly="isReadonly"
            :dataIn="step3Model" @paymentSuccess="onPaymentSuccess"></workflowStep3>
        </el-col>
      </el-row>
      <el-row class="cs-filter-row">
        <el-col :span="16">
          <el-button v-if="
              !!workflowData.Id && !workflowData.IsCompleted
            " size="medium" :disabled="submitBtnDisable || isSaving || isCalculating" :loading="isSaving || isCalculating"
            type="danger" @click="onCancelWorkflow">
            取消报名</el-button>
          <el-button v-if="!workflowData.IsCompleted && activeStep !== 1"
            :disabled="submitBtnDisable || isSaving || isCalculating" :loading="isSaving || isCalculating" size="medium"
            type="primary" @click="onClickPrevious">
            上一步</el-button>
          <el-button v-if="showSubmitBtn" size="medium" :loading="isSaving || isCalculating"
            :disabled="submitBtnDisable || isSaving || isCalculating" :type="submitBtnClass" @click="onClickSave">
            {{ submitBtnText }}</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="completedVisible" top="3vh"
      class="completedMessageDialog">
      <el-row>
        <el-col>
          <img src="../../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row class="completedMessage">
        <el-col>
          <!-- <span>报名成功，电子收据已发送至{{dataIn.memberModel.Email}}</span> -->
          <span>报名成功</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="primary" @click="onCompletedDialogClose">完成</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
  margin-top: 20px;
  border-top: 1px solid #ced3d9;
}
.cs-autonomousEnrolment-workflow {
  .el-col {
    span {
      height: 40px;
      line-height: 40px;
    }
  }

  .el-button {
    margin-left: 20px;
  }

  .cs-filter-row {
    .el-button:first-child {
      margin-left: 0;
    }
  }
}

.completedMessageDialog {
  .el-row {
    padding: 30px;

    .el-col {
      text-align: center;
    }
  }

  .completedMessage {
    font-weight: bold;
  }
}
</style>

<script>
import { CourseListEx } from "./courseListEx";
import workflowStep1 from "./step1";
import workflowStep2 from "./step2";
import workflowStep3 from "./step3";
import { getBonusPointMechanismByType } from "../../../service/bonusPoint.service";
import {
  getCourseSelections,
  getCampusTaxRateList,
} from "../../../service/common.service";
import { getWeekList } from "../../../service/termManage.service";
import {
  getActiveWorkflowDataByStudentId,
  calculateEnrollmentFee,
  saveWorkflowData,
  removeWorkflow,
  getCourseData,
} from "@/service/enrollmentFee.service";
import { getStudentMemberInfo } from "../../../service/student.service";
import {
  convertToFloat,
  getTax,
  toDecimal,
  getYearCourseType,
} from "../../../config/mUtils.js";
import { getStudentAdvanceEnrollmentByStudentId } from "../../../service/advanceEnrollment.service.js";

export default {
  props: {
    studentId: Number,
  },
  data() {
    return {
      isReadonly: false,
      isLoading: false,
      isCalculating: false,
      activeStep: 1,
      currentStepCompleted: false,
      submitBtnDisable: false,
      isSaving: false,
      submitBtnClass: "primary",
      completedVisible: false,
      isEdited: false,
      isStudentAdvanceEnrollmentListLoaded: false,
      studentAdvanceEnrollmentList: [],
      campusTaxRateList: null,
      workflowData: "",
      accountModel: {},
      step1Model: {},
      step2Model: {},
      step3Model: {},
      studentMemberInfo: {},
      totalCourseList: null,
      weekList: null,
      currentWeek: 1,
      priceSettings: {
        bonusPointToMoney_Money: 0,
        bonusPointToMoney_BonusPoint: 0,
      },
      calculateResult: {},
      courseListData: null,
      yearCourseTypeAllList: [],
    };
  },
  components: {
    workflowStep1,
    workflowStep2,
    workflowStep3,
  },
  computed: {
    submitBtnText: function () {
      let text = "下一步";

      if (this.activeStep === 3) {
        text = "完成付款";
      }

      return text;
    },
    showSubmitBtn: function () {
      if (this.workflowData.IsCompleted || this.activeStep == 4) {
        return false;
      }

      if (this.activeStep == 3) {
        let accountAmount = this.courseListData.calcAccountAmount();
        if (accountAmount > 0) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    this.yearCourseTypeAllList = getYearCourseType();

    getBonusPointMechanismByType(2).then((result) => {
      if (result && result.success) {
        this.priceSettings.bonusPointToMoney_Money = result.data.Money;
        this.priceSettings.bonusPointToMoney_BonusPoint =
          result.data.BonusPoint;
      }
    });
    this.init();
  },
  mounted() {},
  methods: {
    async loadActiveWorkflowDataByStudentIdFromServer() {
      try {
        let result = await getActiveWorkflowDataByStudentId(
          this.studentId,
          2,
          true
        );
        if (result && result.success) {
          this.workflowData = result.data;
          this.checkLoading();
        }
      } catch (error) {
        console.error(error);
      }
    },
    async init() {
      this.isStudentAdvanceEnrollmentListLoaded = false;
      this.isLoading = true;
      getCourseSelections().then((result) => {
        if (result && result.success) {
          this.totalCourseList = result.data;
          this.checkLoading();
        }
      });
      getStudentMemberInfo().then((result) => {
        if (result && result.success) {
          this.studentMemberInfo = result.data;
          this.checkLoading();
        }
      });

      getCampusTaxRateList().then((result) => {
        if (!!result && result.success) {
          this.campusTaxRateList = result.data;
          this.checkLoading();
        }
      });

      getStudentAdvanceEnrollmentByStudentId(0).then((result) => {
        if (!!result && result.success) {
          this.studentAdvanceEnrollmentList = result.data;
        }
        this.isStudentAdvanceEnrollmentListLoaded = true;
        this.checkLoading();
      });

      getWeekList().then((result) => {
        if (!!result && result.success) {
          this.weekList = result.data;
          let currentWeekItem = this.weekList.find((i) => i.IsCurrent);
          if (currentWeekItem) {
            this.currentWeek = currentWeekItem.Week;
          } else {
            this.currentWeek = 1;
          }

          this.checkLoading();
        }
      });

      await this.loadActiveWorkflowDataByStudentIdFromServer();
    },
    checkLoading() {
      if (
        this.totalCourseList &&
        this.workflowData &&
        this.studentMemberInfo &&
        this.weekList &&
        this.campusTaxRateList &&
        this.isStudentAdvanceEnrollmentListLoaded
      ) {
        this.initStepModelData();
        this.isLoading = false;
      }
    },
    onBack() {
      this.$emit("close", true);
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.workflowData.CurrentStep) {
          stepStatus = "success";
        } else if (step > this.workflowData.CurrentStep) {
          stepStatus = "wait";
        } else if (this.workflowData.CurrentStep === 4 && step === 4) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.workflowData.CurrentStep)
        return;
      if (this.isSaving || this.isCalculating) {
        return;
      }
      if (this.activeStep != step) {
        if (this.isEdited) {
          this.$message.warning("请点击下一步按钮保存数据");
          return;
        }
        this.activeStep = step;
      }
    },
    initStepModelData() {
      let step = this.workflowData.CurrentStep;
      if (!step) {
        step = 1;
      }
      this.activeStep = step;
      this.courseListData = this.getCourseListEx();

      this.initStep1Model();
      this.initStep2Model();
      this.initStep3Model();

      this.setTaxRate();
    },
    initStep1Model() {
      this.step1Model = {
        studentId: this.studentId,
        workflowId: this.workflowData.Id,
        totalCourseList: this.totalCourseList,
        courseList: this.courseListData,
      };
    },
    initStep2Model() {
      this.step2Model = {
        studentId: this.studentId,
        workflowId: this.workflowData.Id,
        studentMemberInfo: this.studentMemberInfo,
        courseList: this.courseListData,
        model: {
          discountCode: this.workflowData.DiscountCode,
        },
        priceSettings: this.priceSettings,
        studentAdvanceEnrollmentList: this.studentAdvanceEnrollmentList,
        advanceEnrollmentTotalPrice:
          this.workflowData.AdvanceEnrollmentPrice +
          this.workflowData.AdvanceEnrollmentPriceTax,
        modelData: {
          enrollmentCount: this.workflowData.AdvanceEnrollmentCount,
          balance:
            this.workflowData.BalanceCost + this.workflowData.BalanceCostTax,
          balanceTax: this.workflowData.BalanceCostTax,
          bonusPoint: 0, //this.workflowData.BonusPointCost,
          cashDecreased: 0, //this.workflowData.CashDecreasedAmount,
          couponDiscountDollar: 0, //this.workflowData.CouponDiscountDollar,
          studentAdvanceEnrollmentAdditional:
            this.workflowData.StudentAdvanceEnrollmentAdditional,
          comment: this.workflowData.Comment,
        },
      };
    },
    initStep3Model() {
      this.step3Model = {
        studentId: this.studentId,
        workflowId: this.workflowData.Id,
        studentMemberInfo: this.studentMemberInfo,
        courseList: this.courseListData,
        model: {
          paymentType: 0,
        },
      };
    },
    getCourseListEx() {
      let balanceCostTotal = toDecimal(
        this.workflowData.BalanceCost + this.workflowData.BalanceCostTax
      );
      let enrollmentCostTotal = toDecimal(
        this.workflowData.AdvanceEnrollmentPrice +
          this.workflowData.AdvanceEnrollmentPriceTax
      );
      let courseListData = new CourseListEx(
        this.getSelectedCourseList(),
        this.priceSettings,
        this.workflowData.HasTax,
        this.workflowData.TaxRate,
        balanceCostTotal,
        enrollmentCostTotal,
        this.workflowData.TotalPayment
      );
      return courseListData;
    },
    getSelectedCourseList() {
      if (!this.workflowData) return [];
      let selectedCourseList = [];
      for (let i = 0; i < this.workflowData.WorkflowCourses.length; i++) {
        let workflowCourse = this.workflowData.WorkflowCourses[i];
        let courseData = getCourseData(
          this.totalCourseList,
          this.yearCourseTypeAllList,
          workflowCourse.CourseId,
          workflowCourse
        );
        selectedCourseList.push(courseData);
      }
      return selectedCourseList;
    },
    setValueForWorkflowData() {
      this.setTaxRate();
      if (this.activeStep == 1 || this.activeStep == 2) {
        this.workflowData.WorkflowCourses = this.getWorkflowCourseList();
      }
      if (this.activeStep == 2) {
        this.workflowData.BonusPointCost =
          this.workflowData.WorkflowCourses.reduce(
            (sum, x) => sum + x.BonusPointCost,
            0
          );
        this.workflowData.BonusPointAmount =
          this.workflowData.WorkflowCourses.reduce(
            (sum, x) => sum + x.BonusPointAmount,
            0
          );
        this.workflowData.DiscountCode = this.step2Model.model.discountCode;
      }
      let step = this.activeStep + 1;
      if (step > this.workflowData.CurrentStep) {
        this.workflowData.CurrentStep = step;
      }
    },
    onUseBalanceEditorValueChange(result, isMoveNext) {
      let balance = 0;
      let enrollmentCount = 0;
      let studentAdvanceEnrollmentAdditional = "";
      if (!!result.balance) {
        balance = convertToFloat(result.balance);
      }

      if (!!result.enrollmentCount) {
        enrollmentCount = parseInt(result.enrollmentCount);
      }

      if (!!result.studentAdvanceEnrollmentAdditional) {
        studentAdvanceEnrollmentAdditional =
          result.studentAdvanceEnrollmentAdditional;
      }

      this.workflowData.BalanceCost = balance;
      this.workflowData.AdvanceEnrollmentCount = enrollmentCount;
      this.workflowData.StudentAdvanceEnrollmentAdditional =
        studentAdvanceEnrollmentAdditional;

      if (this.workflowData.HasTax) {
        let balanceCost = this.workflowData.BalanceCost;
        let balanceCostTax = getTax(
          this.workflowData.BalanceCost,
          this.workflowData.TaxRate
        );
        this.workflowData.BalanceCost = balanceCost - balanceCostTax;
        this.workflowData.BalanceCostTax = balanceCostTax;
      }

      this.calculatePrice(true);

      if (isMoveNext) {
        this.onClickSave();
      }
    },
    getWorkflowCourseList() {
      let list = [];
      if (this.courseListData && this.courseListData.data) {
        this.courseListData.data.forEach((item) => {
          let courseId = item.CourseId;
          let workflowCourse = this.workflowData.WorkflowCourses.find(
            (i) => i.CourseId == courseId
          );
          if (!workflowCourse) {
            workflowCourse = {
              Id: 0,
              CourseId: courseId,
              CourseName: "",
              CourseCategoryId: 11, //线上课程
              CourseCategoryOptionId: null,
              VipCoursePriceId: null,
              CourseCount: 0,
              IsAdvanceEnrollmentPrice: false,
              IsInternalPrice: false,
              IsOriginalPrice: false,
              IsFreeTrial: false,
              IsVideoFree: false,
              StartWeek: this.currentWeek,
              SupplementVideoType: 3, //可以看所有视频
              SupplementVideoCount: 0,
              ContractId: 0, //未签约
              WeChatGroupType: 0, //未进群
              Comment: "",
              CourseType: 1, //大学补习
              CampusId: null,
              SelectedStudentAdvanceEnrollmentId: 0,
              Price: 0,
              DiscountPrice: 0,
              BonusPointCost: 0,
              BonusPointAmount: 0,
              CourseBalanceCost: 0,
              CashDecreasedAmount: 0,
              YearCourseType: 0,
              CouponCode: "",
              CouponDiscountDollar: 0,
              CourseActivationIdList: [],
              FreeTrialCourseActivationId: 0
            };
          }
          if (this.activeStep == 1) {
            workflowCourse.CourseName = item.CourseName;
            workflowCourse.YearCourseType = item.YearCourseType;
          } else if (this.activeStep == 2) {
            workflowCourse.Price = item.Price;
            workflowCourse.DiscountPrice = item.DiscountPrice;
            workflowCourse.BonusPointCost = item.BonusPointCost;
            workflowCourse.BonusPointAmount = item.BonusPointAmount;
          }

          list.push(workflowCourse);
        });
      }
      return list;
    },
    onCompletedDialogClose() {
      this.completedVisible = false;
      this.$emit("close", true);
    },
    async saveWorkflow() {
      this.isSaving = true;
      let result = await saveWorkflowData(this.workflowData);

      if (result && result.success && !!result.data) {
        this.workflowData.Id = result.data.Id;
        this.workflowData.QRCodeImage = result.data.QRCodeImage;
        this.moveToNext(true);

        if (this.activeStep == 2) {
          await this.calculatePrice(true);
        }

        if (this.workflowData.IsCompleted) {
          this.isReadonly = true;
          this.completedVisible = true;
        } else {
          this.$message.success("保存成功!");
        }
        this.isEdited = false;
      } else {
        this.workflowData.IsCompleted = false;
        this.$message.error(result.message);
      }
      this.isSaving = false;
    },
    async onClickSave() {
      //判断是否修改了余额或占位
      if (this.activeStep == 2) {
        if (this.$refs.workflowStep2.isBalanceEditorChange()) {
          this.$refs.workflowStep2.saveBalanceEditor();
          return;
        }
      }
      
      let msg = "";
      switch (this.activeStep) {
        case 1: {
          if (this.courseListData.data.length == 0) {
            msg = "请选择课程";
          }
          break;
        }
        case 2: {
          let isValid = this.courseListData.isValid();
          if (!isValid) {
            msg =
              "已付总金额已大于应付金额，请重新输入使用的积分，余额，占位。";
          }
          break;
        }
        case 3: {
          if (!this.workflowData.IsCompleted) {
            let isSave = await this.$confirm("是否要完成该流程?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                return true;
              })
              .catch(() => {
                return false;
              });
            if (isSave) {
              this.workflowData.IsCompleted = true;
            } else {
              return false;
            }
          }
          break;
        }
      }

      if (!!msg) {
        this.$message.warning(msg);
        return;
      }

      this.setValueForWorkflowData();

      if (this.activeStep != 4) {
        this.saveWorkflow();
      }
    },
    onClickPrevious() {
      if (this.activeStep > 1) {
        this.activeStep--;
      }
    },
    onCancelWorkflow() {
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isSaving = true;
          removeWorkflow(this.workflowData.Id).then((result) => {
            if (result && result.success) {
              this.$message({
                message: "撤销流程成功",
                type: "success",
              });
              this.loadActiveWorkflowDataByStudentIdFromServer();
            } else {
              this.$message.error(result.message);
            }
            this.isSaving = false;
          });
        })
        .catch(() => {
          this.isSaving = false;
        });
    },
    moveToNext(isReload) {
      if (isReload) {
        switch (this.activeStep) {
          case 1: {
            this.initStep2Model();
            break;
          }
          case 2: {
            this.initStep3Model();
            break;
          }
        }
      }

      this.activeStep++;
    },
    onPaymentSuccess() {
      this.workflowData.IsCompleted = true;
      this.setValueForWorkflowData();
      this.saveWorkflow();
    },
    onCalculate() {
      this.calculatePrice();
    },
    async calculatePrice(hasSet) {
      if (!hasSet) {
        this.setValueForWorkflowData();
      }

      this.isCalculating = true;
      let result = await calculateEnrollmentFee(this.workflowData);

      let isSuccess = false;
      if (result && result.success) {
        isSuccess = true;
        this.calculateResult = result.data;
        this.setCalculationPrice(result.data);
      } else {
        this.$message.error(result.message);
        if (result.exceptionType == 29) {
          //this.step2Model.discountCode = "";
        }
      }
      this.isCalculating = false;
      this.$refs.workflowStep2.finishLoading(isSuccess);
    },
    getCourseIndex(courseId, result) {
      let pre = "CourseId";
      let courseIdList = result.filter((x) => x.Name.includes(pre));
      let item = courseIdList.find((x) => x.Value == courseId);
      let strIndex = item.Name.substring(pre.length);
      let index = parseInt(strIndex);

      return index;
    },
    setCalculationPrice(result) {
      let advanceEnrollmentTotalPrice = this.getVariableResultValue(
        result,
        "AdvanceEnrollmentTotalPrice"
      );
      let advanceEnrollmentTotalPriceTax = 0;
      if (this.workflowData.HasTax) {
        advanceEnrollmentTotalPriceTax =
          advanceEnrollmentTotalPrice * this.workflowData.TaxRate;
      }
      this.workflowData.AdvanceEnrollmentPrice = advanceEnrollmentTotalPrice;
      this.workflowData.AdvanceEnrollmentPriceTax =
        advanceEnrollmentTotalPriceTax;

      if (!!this.courseListData && this.courseListData.data) {
        this.setCourseListData();

        let courseCount = this.courseListData.data.length;

        for (let i = 0; i < courseCount; i++) {
          let item = this.courseListData.data[i];

          let index = this.getCourseIndex(item.CourseId, result);
          item.Price = this.getVariableResultValue(
            result,
            "CoursePrice" + index
          );
          item.DiscountPrice = this.getVariableResultValue(
            result,
            "CourseCouponDiscountPrice" + index
          );
        }
      }
    },
    setCourseListData() {
      this.courseListData.balanceCost = toDecimal(
        this.workflowData.BalanceCost + this.workflowData.BalanceCostTax
      );
      this.courseListData.enrollmentCost = toDecimal(
        this.workflowData.AdvanceEnrollmentPrice +
          this.workflowData.AdvanceEnrollmentPriceTax
      );
    },
    getVariableResultValue(result, name) {
      if (!result) {
        return 0;
      }

      let item = this.getVariableResult(result, name);
      if (!!item) {
        return item.Value;
      }
      return 0;
    },
    getVariableResult(result, name) {
      let item = result.filter((i) => i.Name == name);
      if (item && item.length) {
        return item[0];
      }
      return null;
    },
    onEdit() {
      this.isEdited = true;
    },
    setTaxRate() {
      if (
        (this.activeStep == 1 ||
          (this.workflowData.HasTax && !this.workflowData.TaxRate)) &&
        this.courseListData &&
        this.courseListData.data &&
        this.courseListData.data.length > 0
      ) {
        let courseId = this.courseListData.data[0].CourseId;
        let course = this.totalCourseList.find((i) => i.Id == courseId);

        let campusId = course.CampusList.length > 0 ? course.CampusList[0] : 0;
        let taxRate = this.getCampusTaxRate(campusId);
        if (typeof taxRate == "undefined") {
          taxRate = 0;
        }
        this.workflowData.TaxRate = taxRate;
        this.courseListData.taxRate = taxRate;
      }
    },
    getCampusTaxRate(campusId) {
      if (!!this.campusTaxRateList) {
        let item = this.campusTaxRateList.find((i) => i.CampusId == campusId);
        if (!!item) {
          return item.TaxRate;
        }
      }
      return 0;
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/autonomousEnrolment/workflow/main.vue